import React, { useRef, useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { matchSorter } from 'match-sorter'

import { Search } from '../Forms'
import { MenuSection, MenuLinks } from './Menu'

import { useSession } from '../../providers/SessionProvider'
import truncate from '../../utils/smart-truncate'

const TeamMenu = ({ orgId, teamId }) => {
  const { teams } = useSession({ orgId, teamId })

  const formattedTeams = teams.map(({ name, slug }) => ({
    name: truncate(name, 30),
    id: slug,
    to: `/teams/${slug}`,
    active: teamId ? slug === teamId : false
  }))

  const searchRef = useRef()
  const [links, setLinks] = useState(formattedTeams)

  // Focus the search input when the component mounts
  useEffect(() => {
    searchRef?.current?.focus()
  }, [])

  const filterLinks = () => {
    const searchTerm = searchRef.current.value

    if (searchTerm.length) {
      const matchedTeams = matchSorter(formattedTeams, searchTerm, {
        keys: ['name', 'slug']
      })

      setLinks(matchedTeams)
    } else {
      setLinks(formattedTeams)
    }
  }

  return (
    <>
      <MenuSection>
        <FormattedMessage id="navigation.menu.teams.search.placeholder">
          {label => <Search ref={searchRef} onChange={filterLinks} placeholder={label} width={1} />}
        </FormattedMessage>
      </MenuSection>
      <MenuSection>
        {!links.length ? (
          <FormattedMessage
            id="navigation.menu.teams.search.noResults"
            values={{ searchTerm: searchRef.current.value, strong: chunks => <strong>{chunks}</strong> }}
          />
        ) : (
          <FormattedMessage id="navigation.menu.teams.title">
            {title => <MenuLinks title={title} links={links} />}
          </FormattedMessage>
        )}
      </MenuSection>
    </>
  )
}

export default TeamMenu
